/**
 * Button Component
 * 
 * Reusable styled button component with customizable colors and styling.
 * Used throughout the application for call-to-action and navigation elements.
 * 
 * Interactions:
 * - Uses styled-components for consistent theming and hover effects
 * - Supports custom color, text color
 * - Integrates with global color scheme and typography
 * - Handles click events via onClick prop for navigation and actions
 * - Provides consistent button styling across all components
 */

import { StyledButton } from "./styles";
import { ButtonProps } from "../types";

export const Button = ({ color, children, onClick, boxShadow = false, textColor }: ButtonProps) => (
  <StyledButton color={color} onClick={onClick} boxShadow={boxShadow} textColor={textColor}>
    {children}
  </StyledButton>
);
